import Skeleton from '@ingka/skeleton';
import { translate } from '@repo/phrase';
import { assetStatusTypes } from '@repo/types/asset';
import { Heading, Paragraph } from '@repo/ui/typography';

import { useAssetParams } from '@/hooks/asset.hooks';

import { AssetContextButtons } from './asset-context-buttons';
import { getAssetDetailsTitle } from './status-header.utils';

import styles from './styles.module.scss';

interface Props {
    type?: string | undefined;
    orderAlias?: string | undefined;
    status?: string | undefined;
    createdAt?: string | undefined;
    createdBy?: string | undefined;
    cmpName?: string | undefined;
    paymentStatus?: string | undefined;
}

export const StatusHeader = ({ type, orderAlias, status, createdAt, createdBy, cmpName, paymentStatus }: Props) => {
    const { assetId } = useAssetParams();
    const getTitle = (type: string) => getAssetDetailsTitle(type, orderAlias);

    const isCancelled = status === assetStatusTypes.CANCELLED || status === assetStatusTypes.CANCELED;

    return (
        <div className={styles.order_status} data-testid="order-status-header">
            <div className={styles.order_status_left}>
                <div className={styles.order_status_column}>
                    {type ? <Heading headingSize="xs">{getTitle(type)}</Heading> : <Skeleton />}
                    <Paragraph>{assetId}</Paragraph>
                </div>
                <div className={styles.order_status_column}>
                    <Heading headingSize="xs">{translate('filter_type')}</Heading>
                    <Paragraph>{translate(`order_status_header_type_${type}`)}</Paragraph>
                </div>
                <div className={styles.order_status_column}>
                    <Heading headingSize="xs">{translate('order_status_header_status')}</Heading>
                    <Paragraph>{translate(`asset_list_table_status_${status}`)}</Paragraph>
                </div>
                {!isCancelled && paymentStatus && (
                    <div className={styles.order_status_column}>
                        <Heading headingSize="xs">{translate('order_status_header_payment_status')}</Heading>
                        <Paragraph>{translate(`payment_status_${paymentStatus}`)}</Paragraph>
                    </div>
                )}
                <div className={styles.order_status_column}>
                    <Heading headingSize="xs">{translate('order_status_header_created')}</Heading>
                    <Paragraph>{createdAt ?? '-'}</Paragraph>
                </div>
                <div className={styles.order_status_column}>
                    <Heading headingSize="xs">{translate('order_status_header_cmp')}</Heading>
                    <Paragraph>{cmpName ?? '-'}</Paragraph>
                </div>
                <div className={styles.order_status_column}>
                    <Heading headingSize="xs">{translate('order_status_header_sales_person')}</Heading>
                    <Paragraph>{createdBy}</Paragraph>
                </div>
            </div>
            <div className={styles.order_status_right}>
                <AssetContextButtons />
            </div>
        </div>
    );
};
